import React from 'react'
import './App.css';
//19
const ENTREES=[
  {
    des:"Noix de st jacques bretonnes,couteaux,potimarron,beurre à l'ail",
    price:"20.00"
  },
  {
    des:"Foie gras poêlé/ crème de panais/ coing au sirop",
    price:"20.00"
  },
  {
    des:"Les croquettes aux crevettes grises",
    price:"19.00"
  },
  {
    des:"Cuisses de grenouilles à l'ail",
    price:"16.00"
  },
  {
    des:"Les croquettes au parmesan",
    price:"15.00"
  },
  {
    des:"Ris de veau poêlés aux champignons de saison",
    price:"20.00"
  },
  
]

const PLATS=[
  {
    des:"Dos de cabillaud,légumes de saison,girolles",
    price:"32.00"
  },
  {
  
    des:"Pigeonneau d'Anjou, pommes amandine, garniture de saison",
    price:"38.00"
  },
  {
    des:"Filet pur de boeuf Irlandais, sauce poivres concassés, pommes frites",
    price:"36.00"
  },
  {
    des:"Carré d'agneau rôti en croûte d'herbes,jus à la moutarde",
    price:"36.00"
  },
  {
    des:"Filet pur de boeuf Irlandais aux champignons de saison, pommes frites",
    price:"40.00"
  },
  {
    des:"Filet de cerf,chicon braisé,poire pochée au vin rouge,sauce poivre kerala",
    price:"32.00"
  },
]

const DESSERTS=[
  {
    des:"Meringue aux fruits rouges, glace vanille",
    price:"10.00"
  },
  {
    des:"Moelleux au chocolat glace vanille",
    price:"10.00"
  },
  {
    des:"Tarte fine aux pommes,glace vanille et caramel",
    price:"10.00"
  },
  {
    des:"Crumble aux fruits,glace vanille",
    price:"10.00"
  },
  {
    des:"Dame blanche",
    price:"10.00"
  },
  {
    des:"Assiette de fromages",
    price:"10.00"
  },
  {
    des:"Meringue au chocolat,glace vanille",
    price:"10.00"
  },
]



/*
const HorizontalLine = ({ width, color }) => {
  const lineStyle = {
    width: width || '100%', 
    height: '1px',      
    backgroundColor: color || 'white', 
    margin: '10px 0',      
  };

  return <div style={lineStyle}></div>;
};*/

const CarteComponent=(des, price)=>{

  return(
    <div style={{marginTop:-10,justifyContent:"space-between", flexDirection:"row", display:"flex", width:"100%"}}>
      <p style={{maxWidth:"80%"}}>{des}</p>
      <p style={{fontSize:18}}>{price}€</p>

    </div>
  )
}
function Carte() {
  return (
    
    <div className="origin">
       <title>Carte</title>
       <meta name="description" content="Notre carte"/>
    <div className="gallery-wrapper">
    
  
    <div className="gallery" style={{justifyContent:'center', display:"flex", color:"white", fontFamily:"-moz-initial", fontSize:20, flexDirection:"column", alignItems:"center", width:"100%"}}>
   
     
   

      {/* Carte */}
     <p style={{fontFamily:'fantasy',fontSize:22}}>Carte</p>

     <p style={{fontFamily:"fantasy", fontSize:18, marginTop:20, alignSelf:"flex-start", marginLeft:"10%"}}>Entrées</p>
     <div style={{fontFamily:"-moz-initial",fontSize:20, display:'flex', flexDirection:"column", width:"80%", marginTop:-20}}>

     {ENTREES.map((a, index) => (
            CarteComponent(a.des, a.price)
          ))}

     </div>



     <p style={{ fontFamily:"fantasy", fontSize:18, alignSelf:"flex-start", marginLeft:"10%"}}>Plats</p>
     <div style={{fontFamily:"-moz-initial", fontSize:20, display:'flex', flexDirection:"column", width:"80%",marginTop:-20}}>

     {PLATS.map((a, index) => (
            CarteComponent(a.des, a.price)
          ))}

     </div>

     <p style={{ fontFamily:"fantasy", fontSize:18, alignSelf:"flex-start", marginLeft:"10%"}}>Desserts</p>
     <div style={{fontFamily:"-moz-initial", fontSize:20, display:'flex', flexDirection:"column", width:"80%",marginTop:-20}}>

     {DESSERTS.map((a, index) => (
            CarteComponent(a.des, a.price)
          ))}

     </div>

    </div>
    </div>
    </div>
  );
}

export default Carte
